__turbopack_context__.v({
  "addAnotherButton": "create-game-module__EaPGmG__addAnotherButton",
  "addButton": "create-game-module__EaPGmG__addButton",
  "backLink": "create-game-module__EaPGmG__backLink",
  "builderEnter": "create-game-module__EaPGmG__builderEnter",
  "builderGrid": "create-game-module__EaPGmG__builderGrid",
  "deleteButton": "create-game-module__EaPGmG__deleteButton",
  "detailsPanel": "create-game-module__EaPGmG__detailsPanel",
  "directionButton": "create-game-module__EaPGmG__directionButton",
  "dragHandle": "create-game-module__EaPGmG__dragHandle",
  "editorPanel": "create-game-module__EaPGmG__editorPanel",
  "errorMessage": "create-game-module__EaPGmG__errorMessage",
  "field": "create-game-module__EaPGmG__field",
  "gamePreview": "create-game-module__EaPGmG__gamePreview",
  "itemDragging": "create-game-module__EaPGmG__itemDragging",
  "itemField": "create-game-module__EaPGmG__itemField",
  "itemFields": "create-game-module__EaPGmG__itemFields",
  "itemIdentity": "create-game-module__EaPGmG__itemIdentity",
  "itemList": "create-game-module__EaPGmG__itemList",
  "itemListFooter": "create-game-module__EaPGmG__itemListFooter",
  "itemRow": "create-game-module__EaPGmG__itemRow",
  "itemsHeader": "create-game-module__EaPGmG__itemsHeader",
  "itemsPanel": "create-game-module__EaPGmG__itemsPanel",
  "labelRow": "create-game-module__EaPGmG__labelRow",
  "main": "create-game-module__EaPGmG__main",
  "metricGrid": "create-game-module__EaPGmG__metricGrid",
  "page": "create-game-module__EaPGmG__page",
  "pageHeader": "create-game-module__EaPGmG__pageHeader",
  "pageIcon": "create-game-module__EaPGmG__pageIcon",
  "pageInner": "create-game-module__EaPGmG__pageInner",
  "playButton": "create-game-module__EaPGmG__playButton",
  "prefixField": "create-game-module__EaPGmG__prefixField",
  "previewArtwork": "create-game-module__EaPGmG__previewArtwork",
  "previewCard": "create-game-module__EaPGmG__previewCard",
  "previewCardBody": "create-game-module__EaPGmG__previewCardBody",
  "previewCards": "create-game-module__EaPGmG__previewCards",
  "previewChoice": "create-game-module__EaPGmG__previewChoice",
  "previewColumn": "create-game-module__EaPGmG__previewColumn",
  "previewControls": "create-game-module__EaPGmG__previewControls",
  "previewEnter": "create-game-module__EaPGmG__previewEnter",
  "previewHint": "create-game-module__EaPGmG__previewHint",
  "previewPanel": "create-game-module__EaPGmG__previewPanel",
  "publishNote": "create-game-module__EaPGmG__publishNote",
  "sectionHeading": "create-game-module__EaPGmG__sectionHeading",
  "segmentActive": "create-game-module__EaPGmG__segmentActive",
  "segmentedControl": "create-game-module__EaPGmG__segmentedControl",
  "shareButton": "create-game-module__EaPGmG__shareButton",
  "shareCard": "create-game-module__EaPGmG__shareCard",
  "shareFeedback": "create-game-module__EaPGmG__shareFeedback",
  "shareUrlRow": "create-game-module__EaPGmG__shareUrlRow",
  "spin": "create-game-module__EaPGmG__spin",
  "spinner": "create-game-module__EaPGmG__spinner",
  "submissionPanel": "create-game-module__EaPGmG__submissionPanel",
  "submitButton": "create-game-module__EaPGmG__submitButton",
  "successActions": "create-game-module__EaPGmG__successActions",
  "successBackLink": "create-game-module__EaPGmG__successBackLink",
  "successEnter": "create-game-module__EaPGmG__successEnter",
  "successEyebrow": "create-game-module__EaPGmG__successEyebrow",
  "successIcon": "create-game-module__EaPGmG__successIcon",
  "successIntro": "create-game-module__EaPGmG__successIntro",
  "successView": "create-game-module__EaPGmG__successView",
  "tipsPanel": "create-game-module__EaPGmG__tipsPanel",
  "turnstileWrap": "create-game-module__EaPGmG__turnstileWrap",
  "versusDisk": "create-game-module__EaPGmG__versusDisk",
});
